/* ============
 * Create Page
 * ============
 *
 * This is the page for adding equipments.
 */
import equipmentService from '../../../../services/equipment';
import equipmentTransformer from '../../../../transformers/equipment';
import Forms from '../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        isActive: {
          value: '',
          type: 'checkbox',
        },
      }),
    };
  },

  created() {

  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const equipment = equipmentTransformer.send(this.form.data());
      equipmentService.store(equipment)
        .then(() => {
          this.form.loading = false;
          this.$message({
            message: this.$t('static.equipments.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'production.equipments.index',
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/equipments/create/create.js